import AddVisit from '@/visits/visit/views/user/add/addVisit';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/requests/$id/visit/addRequest',
)({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' });
    }
    
    // validación de roles 
    const { isServicioTecnico, isAsesorComercial } = context.userRoles;
    if (!isServicioTecnico && !isAsesorComercial) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  // // return <AddRequestVisit />
return <AddVisit/>
}